import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Spin } from "antd";
import { ReactComponent as BackIcon } from "../../../assets/back-icon.svg";
import LabDetailsSection from "./labDetailsSection";
import { fetchLab, labDetailCleanupFunc } from "../redux/actions";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";
import { fetchLabStatuses } from "../../LabStatuses/redux/actions";
import "./index.less";
import LabNotifications from "./labNotifications";

const LabDetail = () => {
  const [isLabUpdate, setIsLabUpdate] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();
  const [canUpdate, setCanUpdate] = useState(false);

  const { currentLabObj, fetchLabDetailLoading } = useSelector(
    (state) => state.labsSetupReducer
  );
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (currentLabObj?.id) {
      setIsLabUpdate(true);
    }
  }, [currentLabObj]);

  useEffect(() => {
    if (params?.id) {
      setIsLabUpdate(true);
      dispatch(fetchLab(params?.id));
    } else if (pathname === "/profile") {
      setIsLabUpdate(true);
      dispatch(fetchLab(user.id));
    }

    return () => {
      dispatch(labDetailCleanupFunc());
    };
  }, [params.id]);

  useEffect(() => {
    if (user?.permissions?.labs_setup?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  useEffect(() => {
    dispatch(fetchLabStatuses({ search: {} }));
  }, []);

  return (
    <div className="page-top-div heading-parent-div">
      <Row justify="space-between">
        <Col>
          <span className="text-span">
            {isLabUpdate ? "Update Lab" : "Add Lab"}
          </span>
        </Col>
        {/* {!isProfileCase && ( */}
        <Col>
          <Button
            onClick={() => navigate("/labs-setup")}
            icon={<BackIcon width={24} height={14} />}
            className="back-btn"
            size="middle"
          >
            BACK
          </Button>
        </Col>
        {/* )} */}
      </Row>
      <Spin spinning={fetchLabDetailLoading}>
        <div className="user-manager-parent-div">
          <LabDetailsSection
            isLabUpdate={isLabUpdate}
            canUpdate={canUpdate}
          />
          {false && (
            <LabNotifications
              isLabUpdate={isLabUpdate}
              canUpdate={canUpdate}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default LabDetail;
